import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDZS6OGEcw3KgPlrxJKAs5Io2bicnS8uS4",
  authDomain: "gift-1278.firebaseapp.com",
  projectId: "gift-1278",
  appId: "1:630540475224:web:d7eb6ceb5f57ba5be8a32d",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
